import React from "react";
import Header from "./Header";
import Navigation from "./Navigation";

function Container() {
  return (
    <div className=" w-screen sm:w-4/5 bg-slate-50 mx-auto sm:rounded-2xl shadow-2xl overflow-hidden max-w-4xl">
      <Navigation />
      <Header />
    </div>
  );
}

export default Container;
